import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.AddressValidatorModal.title',
    description: 'Title text',
    defaultMessage: 'Verify Your Shipping Address',
  },
  subtitle1: {
    id: 'components.AddressValidatorModal.subtitle1',
    description: 'Subtitle 1 text',
    defaultMessage:
      'Avoid delivery delays by using our verified shipping address.',
  },
  subtitle2: {
    id: 'components.AddressValidatorModal.subtitle2',
    description: 'Subtitle 2 text',
    defaultMessage:
      'We could not verify your address. Please review and confirm.',
  },
  verifiedAddress: {
    id: 'components.AddressValidatorModal.verifiedAddress',
    description: 'Verified address text',
    defaultMessage: 'Verified Shipping Address',
  },
  addressYouEntered: {
    id: 'components.AddressValidatorModal.addressYouEntered',
    description: 'Address you entered',
    defaultMessage: 'Shipping Address You Entered',
  },
  editManually: {
    id: 'components.AddressValidatorModal.editManually',
    description: 'Edit manually text',
    defaultMessage: 'Edit Manually',
  },
  edit: {
    id: 'components.AddressValidatorModal.edit',
    description: 'Edit text',
    defaultMessage: 'Edit',
  },
  useAddress: {
    id: 'components.AddressValidatorModal.useAddress',
    description: 'Use this address text',
    defaultMessage: 'Use This Address',
  },
  confirmAddress: {
    id: 'components.AddressValidatorModal.confirmAddress',
    description: 'Confirm your address text',
    defaultMessage: 'Confirm Your Address',
  },
  closeModal: {
    id: 'components.AddressValidatorModal.closeModal',
    description: 'Message for the aria label in the close button',
    defaultMessage: 'Close Modal',
  },
});
